import {
  ComponentPropsWithoutRef,
  forwardRef,
  ForwardRefExoticComponent,
  PropsWithoutRef,
  RefAttributes,
} from 'react';
import { selector as formSelector } from '../../form/field/selector-input';

type FR<T, P> = ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>;
type FormSelectorProps = ComponentPropsWithoutRef<typeof formSelector>;

type Props = FormSelectorProps;

export const selector: FR<HTMLSelectElement, Props> = forwardRef((props, ref) => {
  const FormSelector = formSelector;

  return <FormSelector {...props} ref={ref} />;
});

selector.displayName = 'SiloReal-Filter-Field-Selector';
